<template>
  <div id="desktopUpdatePromotion">
    <el-row :gutter="16">
      <el-col :span="8">
        <el-button
          type="primary"
          v-has="'add'"
          size="small"
          icon="el-icon-plus"
          @click="addEditBtn('add')"
          >新增</el-button
        >
      </el-col>
    </el-row>
    <el-row :gutter="16">
      <el-col :span="24">
        <el-form :inline="true" label-suffix="：">
          <el-form-item label="客户号">
            <el-select
              v-model="queryModule.customerId"
              placeholder="请选择客户号"
              clearable
              @change="handleFilterChange"
            >
              <el-option
                v-for="item in filterOptions.customerIds"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道号">
            <el-select
              v-model="queryModule.channelId"
              placeholder="请选择渠道号"
              clearable
              @change="handleFilterChange"
            >
              <el-option
                v-for="item in filterOptions.channelIds"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="项目号">
            <el-select
              v-model="queryModule.projectId"
              placeholder="请选择项目号"
              clearable
              @change="handleFilterChange"
            >
              <el-option
                v-for="item in filterOptions.projectIds"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="安卓平台">
            <el-select
              v-model="queryModule.androidVersion"
              placeholder="请选择安卓平台"
              clearable
              @change="handleFilterChange"
            >
              <el-option
                v-for="item in filterOptions.androidVersions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="目标版本">
            <el-select
              v-model="queryModule.targetVersion"
              placeholder="请选择目标版本"
              clearable
              @change="handleFilterChange"
            >
              <el-option
                v-for="item in filterOptions.targetVersions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            @click="searchList"
            size="small"
            icon="el-icon-search"
            >查询</el-button
          >
        </el-form>
      </el-col>
    </el-row>
    <PageTable
      :columns="tableHead"
      :tableData="{ list: tableList, ...queryModule }"
      @page-change="handleChangePage"
    >
      <!-- 状态 -->
      <template slot-scope="{ row }" slot="status">
        <span
          :style="row.status == 0 ? { color: 'red' } : { color: '#67C23A' }"
          >{{ row.status | typeDesc(onlineStartus) }}</span
        >
      </template>
      <el-table-column label="操作" width="150px" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="addEditBtn('edit', row)"
            v-has="'edit'"
          >
            <span style="color: #409eff">编辑</span>
          </el-button>
          <el-button
            type="text"
            @click="handleStatusChange(row)"
            v-has="'onOff'"
          >
            <span :class="row.status === 1 ? 'colorRed' : 'colorGreen'">{{
              row.status === 1 ? "下线" : "上线"
            }}</span>
          </el-button>
        </template>
      </el-table-column>
    </PageTable>
    <!-- 新增/编辑弹窗 -->
    <AddEditDialog
      ref="addEditDialog"
      :rowData="currentRow"
      :dialogName="dialogName"
      @submitBtn="handleSubmit"
    />
  </div>
</template>

<script>
import PageTable from "@/components/PageTable.vue";
import AddEditDialog from "./components/addEditDialog.vue";
import { onlineStartus } from "@/common/constant/constant.js";
import {
  getFilterOptions,
  getList,
  addRecord,
  editRecord,
  updateStatus,
} from "./api";

export default {
  name: "desktopUpdatePromotion",
  components: { PageTable, AddEditDialog },
  mounted() {
    this.init();
  },
  data() {
    return {
      onlineStartus,
      dialogName: "",
      currentRow: {},
      filterOptions: {
        customerIds: [],
        channelIds: [],
        projectIds: [],
        androidVersions: [],
        targetVersions: [],
      },
      tableHead: [
        { key: "customerId", label: "客户号", align: "center" },
        { key: "channelId", label: "渠道号", align: "center" },
        { key: "projectId", label: "项目号", align: "center" },
        { key: "androidVersion", label: "安卓平台", align: "center" },
        { key: "apkVer", label: "指定版本", align: "center" },
        { key: "targetVersion", label: "目标版本", align: "center" },
        { slot: "status", label: "状态", align: "center" },
        { key: "remarks", label: "备注", align: "center" },
        { key: "createTime", label: "创建时间", align: "center" },
        { key: "modifyTime", label: "修改时间", align: "center" },
      ],
      queryModule: {
        page: 1,
        size: 10,
        total: 0,
        customerId: "",
        channelId: "",
        projectId: "",
        androidVersion: "",
        targetVersion: "",
      },
      tableList: [],
    };
  },
  methods: {
    init() {
      this.getFilterOptions();
      this.getTableList();
    },
    // 获取筛选选项
    getFilterOptions() {
      const params = {
        customerId: this.queryModule.customerId,
        channelId: this.queryModule.channelId,
        projectId: this.queryModule.projectId,
        androidVersion: this.queryModule.androidVersion,
        targetVersion: this.queryModule.targetVersion,
      };
      getFilterOptions(params).then((res) => {
        if (res.code === 0) {
          this.filterOptions = {
            customerIds: res.data.customerIds || [],
            channelIds: res.data.channelIds || [],
            projectIds: res.data.projectIds || [],
            androidVersions: res.data.androidVersions || [],
            targetVersions: res.data.targetVersions || [],
          };
        }
      });
    },
    // 筛选项变化时重新获取筛选选项
    handleFilterChange() {
      this.getFilterOptions();
    },
    // 查询列表
    searchList() {
      this.queryModule.page = 1;
      this.getTableList();
    },
    // 分页
    handleChangePage({ page, size }) {
      this.queryModule.page = page;
      this.queryModule.size = size;
      this.getTableList();
    },
    // 获取表格数据
    getTableList() {
      const params = {
        page: this.queryModule.page,
        size: this.queryModule.size,
        count: true,
        customerId: this.queryModule.customerId,
        channelId: this.queryModule.channelId,
        projectId: this.queryModule.projectId,
        androidVersion: this.queryModule.androidVersion,
        targetVersion: this.queryModule.targetVersion,
      };
      getList(params).then((res) => {
        if (res.code === 0) {
          const { list = [], total = 0 } = res.data;
          this.tableList = list;
          this.queryModule.total = total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增/编辑
    addEditBtn(type, row) {
      if (type === "add") {
        this.dialogName = "新增";
        this.currentRow = {};
      } else {
        this.dialogName = "编辑";
        this.currentRow = row;
      }
      this.$nextTick(() => {
        this.$refs.addEditDialog.init();
      });
    },
    // 提交新增/编辑
    handleSubmit(isAdd, data) {
      if (isAdd) {
        addRecord(data).then((res) => {
          if (res.code === 0) {
            this.$message.success("新增成功");
            this.getFilterOptions();
            this.getTableList();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        editRecord(data).then((res) => {
          if (res.code === 0) {
            this.$message.success("编辑成功");
            this.getFilterOptions();
            this.getTableList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 上线/下线
    handleStatusChange(row) {
      const actionText = row.status === 1 ? "下线" : "上线";
      const newStatus = row.status === 1 ? 0 : 1;
      this.$confirm(`您确定要${actionText}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateStatus({ id: row.id, status: newStatus }).then((res) => {
            if (res.code === 0) {
              this.$message.success(`${actionText}成功`);
              this.getTableList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
#desktopUpdatePromotion {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
